import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import './styles.css';

const OPTIONS = {
  short: { title: 'טיפול קצר', minutes: 60, price: 300 },
  long: { title: 'טיפול ארוך', minutes: null, price: 400 },
};
const LIOR_PHONE = '972528356836';
const PAYBOX_TEST_URL = 'https://links.payboxapp.com/sQMj8V0Rt6b?';
const BIT_TEST_URL = 'https://www.bitpay.co.il/app/share-info?i=9cF5A3IO&j=true';

export default function VoucherDemo({ mode }) {
  const [variant, setVariant] = useState('short');
  const offer = OPTIONS[variant];
  const offerLabel = `${offer.title}${offer.minutes ? ` · ${offer.minutes} דקות` : ''}`;
  const [provider, setProvider] = useState('paybox');
  const [form, setForm] = useState({ buyer: '', buyerEmail: '', recipient: '', recipientEmail: '', phone: '', greeting: '' });
  const [open, setOpen] = useState(false);
  const [reference] = useState(() => `DEMO-${Date.now().toString(36).toUpperCase()}`);
  const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });
  const message = [
    'היי ליאור, זו בקשת הדגמה לשובר מתנה מהאתר. לא בוצע תשלום.',
    `מספר פנייה לדוגמה: ${reference}`,
    `שובר: ${offerLabel}`,
    `מחיר: ${offer.price} ₪`,
    `שם הקונה: ${form.buyer.trim()}`,
    `אימייל הקונה: ${form.buyerEmail.trim()}`,
    form.phone.trim() && `טלפון לחזרה: ${form.phone.trim()}`,
    `שם מקבל/ת המתנה: ${form.recipient.trim()}`,
    `אימייל מקבל/ת המתנה: ${form.recipientEmail.trim()}`,
    form.greeting.trim() && `ברכה: ${form.greeting.trim()}`,
    'אשמח לתאם את התשלום. השובר יישלח רק לאחר אישור קבלת הכסף.',
  ].filter(Boolean).join('\n');
  const whatsappUrl = `https://wa.me/${LIOR_PHONE}?text=${encodeURIComponent(message)}`;

  function submit(event) {
    event.preventDefault();
    setOpen(true);
  }

  return (
    <section className={`voucher-demo voucher-demo--${variant}`} dir="rtl" aria-labelledby="voucher-title">
      <div className="voucher-demo__notice"><span className="voucher-demo__dot" />{mode === 'payment' ? 'דוגמה א׳: קישורי ניסיון לפייבוקס ולביט · תשלום באפליקציה הוא אמיתי' : 'דוגמה ב׳: תיאום בוואטסאפ · ללא חיוב'} · ללא משלוח מיילים</div>
      <div className="voucher-demo__topline">
        <Link to="/voucher">כל האפשרויות / מתחם הניסוי</Link>
        <nav aria-label="בחירת דוגמה" className="voucher-demo__switch">
          <Link to="/voucher/payment" aria-current={mode === 'payment' ? 'page' : undefined}>תשלום ישיר</Link>
          <Link to="/voucher/whatsapp" aria-current={mode === 'whatsapp' ? 'page' : undefined}>דרך וואטסאפ</Link>
        </nav>
      </div>
      <header className="voucher-demo__intro">
        <span className="voucher-demo__eyebrow">{mode === 'payment' ? '01 / ניסיון עם תשלום באפליקציה' : '02 / ניסיון עם תיאום אישי'}</span>
        <h1 id="voucher-title">מתנה של זמן לעצמך</h1>
        <p>שובר לטיפול אצל ליאור שחר. בוחרים טיפול, מוסיפים ברכה ונותנים למישהו אהוב רגע לעצמו.</p>
        <p className="voucher-demo__trial-note">עמוד ניסיוני בלבד. השתמשו בפרטים לדוגמה. {mode === 'payment' ? 'קישורי התשלום הם של רפאל, לא של ליאור; תשלום בניסוי לא מקנה שובר.' : 'הודעה שתשלחו בוואטסאפ תגיע למספר האמיתי של ליאור ותסומן כהדגמה.'}</p>
      </header>

      <div className="voucher-demo__columns">
        <aside className="voucher-demo__preview" aria-label="תצוגה מקדימה של השובר">
          <div className="voucher-demo__original">
            <img src="/voucher-demo/original-voucher.jpeg" alt="השובר המקורי של ליאור שחר לטיפול שיאצו בן 60 דקות, בעיצוב בגוני קרם וזית" />
          </div>
          <p className="voucher-demo__preview-caption">{variant === 'short' ? 'השובר המקורי של ליאור, כפי שצורף.' : 'תמונת העיצוב המקורית מציגה 60 דקות. השובר לטיפול הארוך יקבל גרסה מעודכנת.'}</p>
          <div className="voucher-demo__gift-details">
            <p className="voucher-demo__gift-label">המתנה שבחרתם: {offerLabel}</p>
            <div className="voucher-demo__dedication">
              <span>במיוחד בשביל</span>
              <strong>{form.recipient.trim() || 'מישהו או מישהי שאוהבים'}</strong>
              <p>{form.greeting.trim() || 'כאן תופיע הברכה האישית שלכם.'}</p>
              <small>באהבה, {form.buyer.trim() || 'מכם'}</small>
            </div>
          </div>
          <p className="voucher-demo__preview-caption">תצוגה מקדימה של הברכה. המחיר לא מופיע על המתנה.</p>
          <ol className="voucher-demo__steps">
            <li><span>1</span><div><strong>ממלאים את הפרטים</strong><p>למי המתנה ומה תרצו לכתוב.</p></div></li>
            <li><span>2</span><div><strong>משלמים ומקבלים אישור</strong><p>ליאור מוודא שהכסף התקבל.</p></div></li>
            <li><span>3</span><div><strong>השובר מגיע לשניכם</strong><p>בתהליך המלא, אותו שובר יגיע לקונה ולמקבל המתנה במייל.</p></div></li>
          </ol>
        </aside>

        <div className="voucher-demo__order">
          <div className="voucher-demo__order-heading"><div><span>השובר שבחרתם</span><h2>{offerLabel}</h2></div><strong>{offer.price}<small> ₪</small></strong></div>
          <form onSubmit={submit}>
            <fieldset className="voucher-demo__choose">
              <legend>איזו מתנה תרצו לתת?</legend>
              <div className="voucher-demo__modes">
                {Object.entries(OPTIONS).map(([key, item]) => <label key={key} className={variant === key ? 'is-selected' : ''}>
                  <input type="radio" name="treatment" checked={variant === key} onChange={() => setVariant(key)} />
                  <span><strong>{item.title}</strong><small>{item.minutes ? `${item.minutes} דקות · ` : ''}{item.price} ₪</small></span>
                </label>)}
              </div>
            </fieldset>
            <fieldset>
              <legend>הפרטים שלכם</legend>
              <div className="voucher-demo__fields">
                <label>השם שלכם<input name="buyer" value={form.buyer} onChange={update} required maxLength={80} autoComplete="name" placeholder="שם מלא" pattern=".*\S.*" /></label>
                <label>האימייל שלכם<input name="buyerEmail" value={form.buyerEmail} onChange={update} type="email" required maxLength={150} autoComplete="email" placeholder="name@example.com" dir="ltr" /></label>
              </div>
              <label>טלפון לחזרה <span className="voucher-demo__optional">לא חובה</span><input name="phone" value={form.phone} onChange={update} type="tel" maxLength={25} autoComplete="tel" placeholder="050-0000000" dir="ltr" /></label>
            </fieldset>
            <fieldset>
              <legend>למי המתנה?</legend>
              <div className="voucher-demo__fields">
                <label>שם מקבל/ת המתנה<input name="recipient" value={form.recipient} onChange={update} required maxLength={80} placeholder="למי עושים טוב?" pattern=".*\S.*" /></label>
                <label>אימייל מקבל/ת המתנה<input name="recipientEmail" value={form.recipientEmail} onChange={update} type="email" required maxLength={150} placeholder="gift@example.com" dir="ltr" /></label>
              </div>
              <label>כמה מילים מהלב <span className="voucher-demo__optional">לא חובה</span><textarea name="greeting" value={form.greeting} onChange={update} rows={3} maxLength={300} placeholder="חשבתי שמגיע לך רגע לעצמך..." /></label>
              <p className="voucher-demo__small">אפשר להזין את האימייל שלכם גם בשדה המקבל, אם תרצו למסור את המתנה בעצמכם.</p>
            </fieldset>
            <fieldset>
              <legend>{mode === 'payment' ? 'איך תרצו לשלם?' : 'ממשיכים עם ליאור בוואטסאפ'}</legend>
              {mode === 'payment' ? <div className="voucher-demo__payment-options">
                <label><input type="radio" name="provider" checked={provider === 'paybox'} onChange={() => setProvider('paybox')} />PayBox</label>
                <label><input type="radio" name="provider" checked={provider === 'bit'} onChange={() => setProvider('bit')} />bit</label>
                <p>פייבוקס וביט מחוברים לקבוצות ניסיון שסיפק רפאל. בכל אפליקציה שני הטיפולים פותחים את אותה קבוצת ניסיון; הסכום באפליקציה הוא הקובע ולא מחיר הטיפול כאן. בביט: 1 ₪, עד 15.09.2027 לפי פרטי ההזמנה.</p>
              </div> : <p className="voucher-demo__small">נכין הודעה עם פרטי השובר, שני האימיילים והברכה. תוכלו לבדוק אותה לפני פתיחת וואטסאפ.</p>}
            </fieldset>
            <button type="submit" className="voucher-demo__primary">{mode === 'payment' ? 'לסיכום לפני תשלום' : 'להכנת הודעה לליאור'}<span aria-hidden="true">←</span></button>
            <p className="voucher-demo__footnote">{mode === 'payment' ? 'הפרטים לא נשמרים ולא נשלחים בדוגמה הזו. רענון הדף מוחק אותם.' : 'הפרטים נשארים בדף עד לפתיחת וואטסאפ. רענון הדף מוחק אותם.'}</p>
          </form>
        </div>
      </div>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" PaperProps={{ dir: 'rtl', sx: { borderRadius: '20px' } }}>
        <DialogTitle>{mode === 'payment' ? (provider === 'paybox' ? 'מעבר לקבוצת הניסיון בפייבוקס' : 'מעבר לקבוצת הניסיון בביט') : 'ההודעה שלכם לליאור'}</DialogTitle>
        <DialogContent>
          <div className="voucher-demo__summary">
            <p><strong>{offerLabel} · {offer.price} ₪</strong></p>
            <p>לקונה: {form.buyer} · <bdi>{form.buyerEmail}</bdi><br />למקבל/ת המתנה: {form.recipient} · <bdi>{form.recipientEmail}</bdi></p>
            {mode === 'payment' ? <>
              {provider === 'paybox' ? <p>הקישור יפתח את קבוצת ״בדיקת שובר״ שסיפק רפאל, ולא רכישת שובר מליאור. בדקו את שם המקבל ואת הסכום בפייבוקס לפני אישור. תשלום שתאשרו באפליקציה הוא העברת כסף אמיתית.</p> : <p>הקישור יפתח את קבוצת ״בדיקה״ של רפאל כהן: 1 ₪, עד 15.09.2027 לפי ההזמנה שצורפה. זו בדיקה ולא רכישת שובר מליאור. בדקו את המקבל והסכום בביט לפני אישור; התשלום באפליקציה הוא העברת כסף אמיתית.</p>}
              <p>פרטי המתנה אינם נשלחים לאפליקציית התשלום או נשמרים באתר. האתר אינו מקבל אישור תשלום ולא שולח שובר או מיילים.</p>
              <div className="voucher-demo__qr"><img src={`/voucher-demo/${provider}-qr.svg`} width="184" height="184" alt={`קוד QR לפתיחת קבוצת הניסיון ${provider === 'paybox' ? 'בפייבוקס' : 'בביט'}`} /><div><strong>פותחים מהמחשב?</strong><p>סרקו בטלפון כדי להמשיך באפליקציה. בטלפון אפשר ללחוץ על הכפתור למטה. ייתכן שתידרש התקנת האפליקציה והרשמה.</p></div></div>
            </> : <pre className="voucher-demo__message">{message}</pre>}
            {mode === 'whatsapp' && <p className="voucher-demo__small">פתיחת וואטסאפ תעביר אליו את הפרטים שהזנתם. ההודעה תיפתח כטיוטה, ואתם תבחרו אם לשלוח אותה.</p>}
          </div>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1, flexWrap: 'wrap' }}>
          <Button onClick={() => setOpen(false)}>חזרה לעריכה</Button>
          {mode === 'whatsapp' ? <Button component="a" href={whatsappUrl} target="_blank" rel="noopener noreferrer" variant="contained" sx={{ bgcolor: '#345947', '&:hover': { bgcolor: '#264535' } }}>לפתיחת הטיוטה בוואטסאפ</Button> : <Button component="a" href={provider === 'paybox' ? PAYBOX_TEST_URL : BIT_TEST_URL} target="_blank" rel="noopener noreferrer" variant="contained">לפתיחת קבוצת הניסיון {provider === 'paybox' ? 'בפייבוקס' : 'בביט'}</Button>}
        </DialogActions>
      </Dialog>
    </section>
  );
}
